.select {
  width: 100%;
}
